import * as React from 'react';

import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { Translate } from 'react-localize-redux';

import AppState from '@webapp/store/state';
import { getOwnershipTotal } from '@webapp/store/ownership/selectors';

import styled from 'styled-components';

import SidebarCtrl, { SidebarSection } from '../../sidebar';
import NavbarItemAvatarCtrl from '@webapp/controllers/navbar/navbar-actions/navbar-items/navbar-item-avatar';

interface MerchSidebarCtrlProps {
  className?: string;
  isMobile: boolean;
  isEdit?: boolean;
  productSelectionDone: boolean;
  colorSizeSelectionDone: boolean;
  designSelectionDone: boolean;
  pricingOwnersDone: boolean;
  previewEnabled: boolean;
  previewDone: boolean;
}

const mapStateToProps = (state: AppState) => {
  const productId =
    state.merch.active?.editProduct?.id ||
    state.merch.active?.newProduct?.productId;

  return {
    isMobile: state.ui.mobile,
    productSelectionDone:
      !!state.merch.active?.product || !!state.merch.active?.editProduct,
    colorSizeSelectionDone:
      !!state.merch.active?.selectedColors &&
      !!state.merch.active?.selectedColors.length &&
      !!state.merch.active?.selectedSizes &&
      !!state.merch.active?.selectedSizes?.length,
    designSelectionDone:
      !!state.merch?.active?.image &&
      (!!state.merch.active?.position ||
        !!state.merch.active?.editProduct?.printify[0].position),
    previewEnabled:
      !!state.merch?.active?.newProduct?.productId ||
      !!state.merch?.active?.editProduct,
    previewDone: !!productId && !!state.merch?.active?.productData,
    pricingOwnersDone:
      !!productId &&
      !!state.merch?.active?.productData?.productName &&
      !!state.merch?.active?.productData?.productPrice &&
      getOwnershipTotal(state.ownership, productId, 'OWNER') === 100 &&
      Number(state.merch?.active?.productData?.productPrice) >=
        (state.merch?.active?.editProduct?.cost ||
          Number(state.merch?.active?.newProduct?.pricing?.production_cost)),
  };
};

export const MerchSidebarCtrl: React.FC<MerchSidebarCtrlProps> = ({
  isEdit = false,
  productSelectionDone,
  colorSizeSelectionDone,
  designSelectionDone,
  previewEnabled,
  previewDone,
  pricingOwnersDone,
  ...props
}) => {
  const match = useRouteMatch<{ merchId: string }>();
  const merchId = match.params.merchId;
  const baseUrl = isEdit ? `/merch/edit/${merchId}` : '/merch';

  const selectProduc: SidebarSection[] = [
    {
      path: `${baseUrl}/select-product`,
      label: <Translate id="MERCH.SECTIONS.PRODUCT" />,
      disabled: false,
      done: productSelectionDone,
    },
  ];

  const commonSections: SidebarSection[] = [
    {
      path: `${baseUrl}/color-size`,
      label: <Translate id="MERCH.SECTIONS.COLOR" />,
      disabled: !productSelectionDone,
      done: colorSizeSelectionDone,
    },
    {
      path: `${baseUrl}/design`,
      label: <Translate id="MERCH.SECTIONS.DESIGN" />,
      disabled: !colorSizeSelectionDone,
      done: designSelectionDone,
    },
    {
      path: `${baseUrl}/pricing-owners`,
      label: <Translate id="MERCH.SECTIONS.PRICING" />,
      disabled: !previewDone,
      done: pricingOwnersDone,
    },
  ];

  const sections = isEdit
    ? commonSections
    : selectProduc.concat(commonSections);
  return (
    <div className={props.className}>
      {props.isMobile ? (
        <StyledNavbarItemAvatarCtrl className="navbar-artist-mobile" noHover />
      ) : null}
      <SidebarCtrl title={<Translate id="MERCH.TITLE" />} sections={sections} />
    </div>
  );
};

export default connect(mapStateToProps)(MerchSidebarCtrl);

const StyledNavbarItemAvatarCtrl = styled(NavbarItemAvatarCtrl)`
  padding: 0;
  margin-bottom: 30px;
`;
